import { StyledComponent } from '@emotion/styled';
import { styled, ToggleButton as MuiToggleButton, toggleButtonClasses, ToggleButtonProps } from '@mui/material';

export const ToggleButton: StyledComponent<ToggleButtonProps> = styled(MuiToggleButton)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: 'black',
  [`&.${toggleButtonClasses.selected}`]: {
    borderColor: theme.palette.primary.main,
  },
}));
